import taskInstancesHeaderUrl from './taskInstancesHeader.html';

class TaskInstancesHeaderCtrl {
  constructor(Authentication, ShiftTasksService, ShiftTasksTabsService, Utils, sdk, $scope) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ShiftTasksService,
      ShiftTasksTabsService,
      Utils,
      sdk,
      $scope,
    });

    Utils.extendWithProps(sdk('constants'), this, [
      'TASK_INSTANCES_GROUP_BY_STATUS',
      'TASK_INSTANCES_SORT_BY_DATE',
      'TASK_INSTANCES_SORT_BY_STATUS',
    ]);
  }

  $onInit() {
    this.modeWatcher = this.$scope.$watch('ctrl.ShiftTasksService.mode', (newMode) => {
      if (this.Authentication.user.clientcache.taskInstances) {
        this.Authentication.user.clientcache.taskInstances.mode = newMode;
        this.Authentication.syncClientCache();
      }
    });

    this.shouldDisplayTabs = this.ShiftTasksTabsService.shouldDisplayTabs();
  }

  $onDestroy() {
    this.modeWatcher();
  }

  jumpToToday = () => {
    if (!this.isTodaySelected) {
      this.ShiftTasksService.setReferenceDate();
    }
  };

  changeGroupMethod = (method) => {
    if (method === this.TASK_INSTANCES_GROUP_BY_STATUS) {
      this.ShiftTasksService.changeSortMethod(this.TASK_INSTANCES_SORT_BY_DATE);
    }
    this.ShiftTasksService.changeGroupMethod(method);
  };

  get isFeatureAvailable() {
    return this.ShiftTasksService.isFeatureEnabled;
  }

  get canDisplaySortOptions() {
    return this.ShiftTasksService.groupMethod !== this.TASK_INSTANCES_SORT_BY_STATUS;
  }
}

export default {
  templateUrl: taskInstancesHeaderUrl,
  controller: TaskInstancesHeaderCtrl,
  controllerAs: 'ctrl',
  bindings: {
    hasEvents: '<',
  },
};
